import { render, staticRenderFns } from "./msg1.vue?vue&type=template&id=08dd5b47&scoped=true&"
import script from "./msg1.vue?vue&type=script&lang=js&"
export * from "./msg1.vue?vue&type=script&lang=js&"
import style0 from "./msg1.vue?vue&type=style&index=0&id=08dd5b47&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dd5b47",
  null
  
)

export default component.exports